import React, { useState } from "react";
import { BsCheckCircleFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import { logoLight } from "../../assets/images";
import { Helmet } from "react-helmet";

const SignUp = () => {
  const [clientName, setClientName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [zip, setZip] = useState("");
  const [checked, setChecked] = useState(false);

  const [errClientName, setErrClientName] = useState("");
  const [errEmail, setErrEmail] = useState("");
  const [errPhone, setErrPhone] = useState("");
  const [errPassword, setErrPassword] = useState("");
  const [errAddress, setErrAddress] = useState("");
  const [errCity, setErrCity] = useState("");
  const [errCountry, setErrCountry] = useState("");
  const [errZip, setErrZip] = useState("");

  const [successMsg, setSuccessMsg] = useState("");

  const handleName = (e) => { setClientName(e.target.value); setErrClientName(""); };
  const handleEmail = (e) => { setEmail(e.target.value); setErrEmail(""); };
  const handlePhone = (e) => { setPhone(e.target.value); setErrPhone(""); };
  const handlePassword = (e) => { setPassword(e.target.value); setErrPassword(""); };
  const handleAddress = (e) => { setAddress(e.target.value); setErrAddress(""); };
  const handleCity = (e) => { setCity(e.target.value); setErrCity(""); };
  const handleCountry = (e) => { setCountry(e.target.value); setErrCountry(""); };
  const handleZip = (e) => { setZip(e.target.value); setErrZip(""); };

  const EmailValidation = (email) => {
    return String(email).toLowerCase().match(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i);
  };

  const handleSignUp = (e) => {
    e.preventDefault();
    if (!checked) return;

    if (!clientName) setErrClientName("Enter your full name");
    if (!email) setErrEmail("Enter your email");
    else if (!EmailValidation(email)) setErrEmail("Enter a valid email address");
    if (!phone) setErrPhone("Enter your phone number");
    if (!password) setErrPassword("Create a password");
    else if (password.length < 6) setErrPassword("Password must be at least 6 characters");
    if (!address) setErrAddress("Enter your address");
    if (!city) setErrCity("Enter your city");
    if (!country) setErrCountry("Enter your country");
    if (!zip) setErrZip("Enter your zip/postal code");

    if (
      clientName &&
      email &&
      EmailValidation(email) &&
      password &&
      password.length >= 6 &&
      address &&
      city &&
      country &&
      zip
    ) {
      setSuccessMsg(
        `Welcome ${clientName}! Your account request at RK Global Trader has been received. We are validating your registration. Further instructions will be sent to your email: ${email}.`
      );
      setClientName(""); setEmail(""); setPhone(""); setPassword(""); setAddress(""); setCity(""); setCountry(""); setZip("");
    }
  };

  return (
    <div className="w-full h-screen flex items-center justify-start bg-gray-50">
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>Sign Up - RK Global Trader | International Export & Import Platform</title>
        <meta name="description" content="Create your RK Global Trader account to access premium international export and import services. Secure signup for verified traders and partners." />
        <meta name="keywords" content="RK Global Trader signup, international trade registration, export import account, global trading platform signup, secure account RK Global Trader" />
        <meta name="author" content="RK Global Trader | Export & Import from India" />
        <link rel="canonical" href="https://www.rkglobaltrader.com/signup" />
      </Helmet>

      {/* Left Info Panel */}
      <div className="w-1/2 hidden lgl:flex h-full bg-primeColor text-white flex-col px-10 justify-center gap-6">
        <Link to="/">
          <img src={logoLight} alt="RK Global Trader Logo" className="w-28" />
        </Link>
        <h1 className="font-titleFont text-xl font-medium">Get Started for Free</h1>
        <p className="text-base">Create your account to access premium international trade services</p>

        <div className="flex flex-col gap-3">
          <div className="flex items-start gap-3">
            <BsCheckCircleFill className="text-green-500 mt-1" />
            <p className="text-base text-gray-300">
              <strong className="text-white">Fast Setup:</strong> Start trading globally with RK Global Trader in a few simple steps.
            </p>
          </div>
          <div className="flex items-start gap-3">
            <BsCheckCircleFill className="text-green-500 mt-1" />
            <p className="text-base text-gray-300">
              <strong className="text-white">Secure Platform:</strong> All accounts are verified and protected for safe international trading.
            </p>
          </div>
          <div className="flex items-start gap-3">
            <BsCheckCircleFill className="text-green-500 mt-1" />
            <p className="text-base text-gray-300">
              <strong className="text-white">Trusted by Traders:</strong> Join a growing network of verified global traders and import/export partners.
            </p>
          </div>
        </div>

        <div className="flex justify-between mt-10 text-sm text-gray-300">
          <p>© RK Global Trader</p>
          <p>Terms</p>
          <p>Privacy</p>
          <p>Security</p>
        </div>
      </div>

      {/* Sign Up Form */}
      <div className="w-full lgl:w-[500px] h-full flex flex-col justify-center">
        {successMsg ? (
          <div className="w-full px-4 py-10">
            <p className="text-green-600 text-center font-titleFont font-medium">{successMsg}</p>
            <Link to="/signin">
              <button className="w-full h-10 bg-primeColor rounded-md text-white font-semibold mt-4 hover:bg-black hover:text-gray-100 transition duration-300">
                Sign In
              </button>
            </Link>
          </div>
        ) : (
          <form className="w-full lgl:w-[500px] h-screen flex items-center justify-center">
            <div className="px-6 py-4 w-full h-[96%] flex flex-col justify-start overflow-y-scroll scrollbar-thin scrollbar-thumb-primeColor">
              <h1 className="font-titleFont underline underline-offset-4 decoration-[1px] font-semibold text-2xl mdl:text-3xl mb-4 text-center">
                Create Your Account
              </h1>

              <div className="flex flex-col gap-3">
                {/* Full Name */}
                <div className="flex flex-col">
                  <label className="font-titleFont text-gray-600 font-semibold">Full Name</label>
                  <input type="text" value={clientName} onChange={handleName} placeholder="Full Name"
                    className="w-full h-8 px-4 text-base border rounded-md outline-none focus:ring-2 focus:ring-primeColor" />
                  {errClientName && <p className="text-red-500 text-sm">{errClientName}</p>}
                </div>

                {/* Email */}
                <div className="flex flex-col">
                  <label className="font-titleFont text-gray-600 font-semibold">Work Email</label>
                  <input type="email" value={email} onChange={handleEmail} placeholder="email@workemail.com"
                    className="w-full h-8 px-4 text-base border rounded-md outline-none focus:ring-2 focus:ring-primeColor" />
                  {errEmail && <p className="text-red-500 text-sm">{errEmail}</p>}
                </div>

                {/* Phone */}
                <div className="flex flex-col">
                  <label className="font-titleFont text-gray-600 font-semibold">Phone Number</label>
                  <input type="text" value={phone} onChange={handlePhone} placeholder="+91- 0000000000"
                    className="w-full h-8 px-4 text-base border rounded-md outline-none focus:ring-2 focus:ring-primeColor" />
                  {errPhone && <p className="text-red-500 text-sm">{errPhone}</p>}
                </div>

                {/* Password */}
                <div className="flex flex-col">
                  <label className="font-titleFont text-gray-600 font-semibold">Password</label>
                  <input type="password" value={password} onChange={handlePassword} placeholder="Create password"
                    className="w-full h-8 px-4 text-base border rounded-md outline-none focus:ring-2 focus:ring-primeColor" />
                  {errPassword && <p className="text-red-500 text-sm">{errPassword}</p>}
                </div>

                {/* Address */}
                <div className="flex flex-col">
                  <label className="font-titleFont text-gray-600 font-semibold">Address</label>
                  <input type="text" value={address} onChange={handleAddress} placeholder="Road-001, House-115"
                    className="w-full h-8 px-4 text-base border rounded-md outline-none focus:ring-2 focus:ring-primeColor" />
                  {errAddress && <p className="text-red-500 text-sm">{errAddress}</p>}
                </div>

                {/* City */}
                <div className="flex flex-col">
                  <label className="font-titleFont text-gray-600 font-semibold">City</label>
                  <input type="text" value={city} onChange={handleCity} placeholder="Your city"
                    className="w-full h-8 px-4 text-base border rounded-md outline-none focus:ring-2 focus:ring-primeColor" />
                  {errCity && <p className="text-red-500 text-sm">{errCity}</p>}
                </div>

                {/* Country */}
                <div className="flex flex-col">
                  <label className="font-titleFont text-gray-600 font-semibold">Country</label>
                  <input type="text" value={country} onChange={handleCountry} placeholder="Your country"
                    className="w-full h-8 px-4 text-base border rounded-md outline-none focus:ring-2 focus:ring-primeColor" />
                  {errCountry && <p className="text-red-500 text-sm">{errCountry}</p>}
                </div>

                {/* Zip */}
                <div className="flex flex-col">
                  <label className="font-titleFont text-gray-600 font-semibold">Zip/Postal Code</label>
                  <input type="text" value={zip} onChange={handleZip} placeholder="Your postal code"
                    className="w-full h-8 px-4 text-base border rounded-md outline-none focus:ring-2 focus:ring-primeColor" />
                  {errZip && <p className="text-red-500 text-sm">{errZip}</p>}
                </div>

                {/* Terms Checkbox */}
                <div className="flex items-start gap-2 mt-2">
                  <input type="checkbox" checked={checked} onChange={() => setChecked(!checked)} className="w-4 h-4 mt-1 cursor-pointer" />
                  <p className="text-sm text-primeColor">
                    I agree to the <span className="text-blue-500">Terms of Service</span> and <span className="text-blue-500">Privacy Policy</span>.
                  </p>
                </div>

                <button onClick={handleSignUp} className={`w-full h-10 mt-3 rounded-md text-white font-semibold transition duration-300 ${checked ? "bg-primeColor hover:bg-black hover:text-gray-100 cursor-pointer" : "bg-gray-500 cursor-not-allowed"}`}>
                  Create Account
                </button>

                <p className="text-sm text-center mt-2">
                  Already have an account?{" "}
                  <Link to="/signin"><span className="text-blue-600 hover:text-blue-800">Sign In</span></Link>
                </p>
              </div>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default SignUp;
